import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import "firebase/firestore";
import { getAuth } from "firebase/auth";
import { config } from "./config";

const app = initializeApp(config.firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);